export const DEFAULT_OPENAI_MODEL = 'gpt-5.5'
export const DEFAULT_ANTHROPIC_MODEL = 'claude-sonnet-4-6'
export const DEFAULT_GEMINI_MODEL = 'gemini-3-flash-preview'
